// extracted by mini-css-extract-plugin
export var divider = "_g2-7";
export var itemsToggle = "_g2-8";
export var mergeModal = "_g2-1";
export var optionCard = "_g2-4";
export var radioGroup = "_g2-6";
export var radioOption = "_g2-0";
export var selected = "_g2-5";
export var shipmentOptions = "_g2-2";
export var tableOptions = "_g2-3";